module.exports = __webpack_public_path__ + "5a2afde8cac1931fa2476d9e37307b0d.fbx";